<template>
  <transition name="modal-fade">
    <div
      v-if="show"
      class="fixed inset-0 z-[101] flex"
      :class="isPC ? 'items-center justify-center' : 'items-end'"
    >
      <!-- 遮罩 -->
      <div
        class="absolute inset-0 bg-[#1c1c1c] bg-opacity-60"
        @click="handleMaskClick"
      />

      <!-- 内容容器 -->
      <transition :name="isPC ? 'modal-scale' : 'modal-slide'">
        <div
          v-if="show"
          class="relative z-[1]"
          :class="isPC ? 'max-w-[90vw]' : 'w-full'"
        >
          <slot name="header" />
          <div
            class="rounded-[20px] bg-white px-[40px] pt-[40px] pb-[48px]"
            :class="bodyClass"
            :style="isPC && contentWidth ? { width: contentWidth } : {}"
          >
            <slot />
          </div>
          <!-- 关闭按钮 -->
          <img
            v-if="closable"
            class="block mx-auto cursor-pointer w-[36px] h-[36px] mt-[38px]"
            src="../images/close-icon.png"
            @click="handleClose"
          />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script lang="ts">
import { use as fegoUse } from '@fegobull/webapi';
import { useFegoPageInfo } from '@ark/web-shared/use';
const __sfc_main = {};
__sfc_main.props = {
  show: {
    key: "show",
    required: true,
    type: Boolean
  },
  closable: {
    key: "closable",
    required: false,
    type: Boolean,
    default: true
  },
  closeOnMask: {
    key: "closeOnMask",
    required: false,
    type: Boolean,
    default: true
  },
  contentWidth: {
    key: "contentWidth",
    required: false,
    type: String,
    default: ''
  },
  bodyClass: {
    key: "bodyClass",
    required: false,
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useTeleport
  } = fegoUse;
  useTeleport(document.body);
  const props = __props;
  const emit = __ctx.emit;
  const {
    isPC
  } = useFegoPageInfo();
  function handleClose() {
    emit('update:show', false);
    emit('close');
  }
  function handleMaskClick() {
    if (props.closeOnMask) {
      handleClose();
    }
  }
  return {
    isPC,
    handleClose,
    handleMaskClick
  };
};
export default __sfc_main;
</script>

<style scoped>
/* 遮罩淡入淡出 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

/* PC：缩放 */
.modal-scale-enter-active,
.modal-scale-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.modal-scale-enter,
.modal-scale-leave-to {
  transform: scale(0.9);
  opacity: 0;
}

/* H5：底部滑入 */
.modal-slide-enter-active,
.modal-slide-leave-active {
  transition: transform 0.3s ease;
}
.modal-slide-enter,
.modal-slide-leave-to {
  transform: translateY(100%);
}
</style>
